export enum OpenSiteModalType {
    Demo = 'Demo',
    Signup = 'Signup'
}